import React from "react";
import PropTypes from "prop-types";
import PersonPreview from "components/PersonPreview";
import BlackListAlert from "../../../../../entities/BlacklistTooltip/index";

const ModalItem = ({
    blacklisted,
    isPlayerSigned,
    member,
    isInvate = true,
}) => {
    return (
        <div className="players-list__item">
            <PersonPreview
                {...member}
                mods={{
                    "person--row": true,
                    person_disabled: isPlayerSigned,
                }}
            />

            {!!blacklisted && !!blacklisted?.length && (
                <BlackListAlert blacklisted={blacklisted} id={member?.id} />
            )}

            {isInvate && (
                <div className="players-list__right mr-15">
                    {isPlayerSigned ? (
                        <p className="fs-caption ml-auto text_gs-label-disabled">
                            Записался
                        </p>
                    ) : (
                        <p className="fs-caption ml-auto c-gs-label">
                            Приглашён
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

ModalItem.propTypes = {
    blacklisted: PropTypes.bool,
    isPlayerSigned: PropTypes.bool,
    member: PropTypes.object,
    isInvate: PropTypes.bool,
};

export default ModalItem;
